// components/BuscadorClienteFactura/constants.js
export const OPCIONES_FILTROS = [
  { value: "razon_social", label: "Razón Social", icon: "👤" },
  { value: "cuit", label: "CUIT", icon: "📋" },
  { value: "dni", label: "DNI", icon: "🆔" },
  { value: "sisven", label: "SISVEN", icon: "🔢" },
  { value: "direccion", label: "Dirección", icon: "🏠" },
  { value: "localidad", label: "Localidad", icon: "🏙️" },
  { value: "telefono", label: "Teléfono", icon: "📞" },
];

export const FILTROS_POR_DEFECTO = ["razon_social", "cuit"];

export const FACTURACION_PROPIA = {
  id: 'SELF',
  razon_social: 'Facturación Propia'
};